/*
 * @Author: lzy
 * @Date: 2021-05-11 15:53:07
 * @LastEditTime: 2021-05-12 11:06:13
 * @LastEditors: lzy
 * @Description: app详情页顶部操作按钮
 * @FilePath: \xjmediacloud\app\editingCenter\app\directive\previewBtns\previewBtns.js
 */

angular.module('appPreviewModule').directive('appPreviewBtns', ['$state', 'newMediaService', 'messagePublishService', 'sensitiveWordCheckService', 'editingCenterService', 'modalDialog', 'publicToolService', 'appConst',
    function($state, newMediaService, messagePublishService, sensitiveWordCheckService, editingCenterService, modalDialog, publicToolService, appConst) {
        return {
            scope: true,
            restrict: 'EA',
            replace: true,
            templateUrl: './editingCenter/app/preview/previewBtns/previewBtns.html',
            link: function($scope, $element, $attrs) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化数据
                 *
                 * @return  {[type]}   [return description]
                 */
                function initStatus() {
                    $scope.data.trench = appConst.params.listenStroageKey;
                    $scope.list = $scope.data.item;
                }

                /**
                 * [initData description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function initData() {
                    // publicToolService.getModeconfiguration('IM').then((config) => {
                    //     // 因为发送按钮不基于权限控制，只根据配置中心来决定，在这里添加可以便于修改每个编辑页面
                    //     $scope.status.canSendMessage = config && config.sendSwitch === 'on';
                    // });
                }

                /* 送审 */
                $scope.trial = function() {
                    $scope.loadingPromise = newMediaService.trial($scope, appConst.params.trialParams).then(function(opinion) {
                        let trialParams = angular.extend({
                            MetaDataIds: $scope.list.METADATAID,
                            ChnlDocIds: $scope.list.CHNLDOCID,
                            ChannelId: $state.params.appchannelid,
                            Opinion: opinion,
                        }, appConst.params.trialParams);
                        messagePublishService.publish('doEditPageOperation', trialParams);
                    });
                };

                /* 直接签发 */
                $scope.directiveSign = function() {
                    sensitiveWordCheckService.SensitiveWordsAndCareful([$scope.list], true, '1').then(
                        function () {
                            signPrivate();
                        },
                        function () {
                            signPrivate();
                        }
                    );
                };

                /**
                 * [signPrivate description] 直接签发
                 *
                 * @return  {[type]}   [return description]
                 */
                function signPrivate() {
                    var methodname = ['appDaiBianPublish', 'appDaiShenPublish', 'appYiQianFaPublish'];
                    $scope.loadingPromise = newMediaService.sign($scope).then(function () {
                        let signParams = {
                            serviceid: 'mlf_appoper',
                            methodname: methodname[$state.params.appplatform],
                            ObjectIds: $scope.list.CHNLDOCID,
                            ChnlDocIds: $scope.list.CHNLDOCID,
                            MetaDataIds: $scope.list.METADATAID,
                        };
                        messagePublishService.publish('doEditPageOperation', signParams);
                    });
                }

                /* 定时签发 */
                $scope.timeSign = function() {
                    var methodname = ['appDaiBianTimingPublish', 'appDaiShenTimingPublish'];
                    $scope.loadingPromise = newMediaService.timeSign($scope).then(function () {
                        let signParams = {
                            serviceid: 'mlf_appoper',
                            methodname: methodname[$state.params.appplatform],
                            ObjectIds: $scope.list.CHNLDOCID,
                            ChnlDocIds: $scope.list.CHNLDOCID,
                            MetaDataIds: $scope.list.METADATAID,
                        };
                        messagePublishService.publish('doEditPageOperation', signParams);
                    });
                };

                /* 废稿 */
                $scope.deleteDraft = function() {
                    $scope.loadingPromise = newMediaService.delete($scope, appConst.params.delete);
                };

                // 撤稿
                $scope.revoke = function() {
                    newMediaService.rejection($scope, appConst.params.rejectionParams).then((opinion) => {
                        let KillParams = angular.extend({
                            ChnlDocIds: $scope.list.CHNLDOCID,
                            MetaDataIds: $scope.list.METADATAID,
                            Opinion: opinion,
                            ChannelId: $state.params.appchannelid,
                        }, appConst.params.rejectionParams);
                        messagePublishService.publish('doEditPageOperation', KillParams);
                    });
                };

                /**
                 * [revise description]修订
                 * @return {[type]} [description]
                 */
                $scope.revise = function () {
                    var transferData = {
                        SiteId: $state.params.appsiteid,
                        DocIds: $scope.data.item.METADATAID,
                        ChnlDocIds: $scope.data.item.CHNLDOCID,
                        UserId: '',
                        MediaType: '1',
                    };
                    newMediaService.revise($scope, transferData);
                };

                // 取消签发
                $scope.retraction = function() {
                    $scope.loadingPromise = editingCenterService.beforeRetractOper([$scope.data.item]).then(function (data) {
                        if (data === 'noneed') {
                            retraction();
                        } else {
                            editingCenterService.beforeRetractionModel({
                                data: data,
                                selectedArray: [$scope.data.item],
                            }, function () {
                                retraction();
                            });
                        }
                    });
                };

                /**
                 * [retraction description]取消签发函数
                 * @return  {[type]}              [return description]
                 */
                function retraction() {
                    newMediaService.retraction($scope, appConst.params.retraction);
                }

                /**
                 * [tenantManuShare 租户间共享]
                 * @return {[type]} [description]
                 */
                $scope.tenantManuShare = function () {
                    if ([3, 5, 6, 12, 13].indexOf($scope.data.item.DOCTYPEID) > -1) {
                        modalDialog.alertType('无法进行共享', '所选稿件中包含活动稿、专题稿、音频稿和话题稿', 'info', 'confirm', function () { });
                        return;
                    }
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'pluralisticShare',
                        dataIds: $scope.data.item.METADATAID,
                        ChnlDocIds: $scope.data.item.CHNLDOCID,
                    };
                    $scope.loadingPromise = editingCenterService.tenantShareManu(params);
                };
            }
        };
    }
]);
